import { render, staticRenderFns } from "./ModalForgotPinByPhone.vue?vue&type=template&id=43addbde&"
import script from "./ModalForgotPinByPhone.vue?vue&type=script&lang=js&"
export * from "./ModalForgotPinByPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports